import { render } from "./LaborersAttendanceConfigClassmate.vue?vue&type=template&id=4adfdd14&scoped=true"
import script from "./LaborersAttendanceConfigClassmate.vue?vue&type=script&lang=js"
export * from "./LaborersAttendanceConfigClassmate.vue?vue&type=script&lang=js"

import "./LaborersAttendanceConfigClassmate.vue?vue&type=style&index=0&id=4adfdd14&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adfdd14"],['__file',"src/views/h5/luqiao/laborers/attendance/config/LaborersAttendanceConfigClassmate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4adfdd14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4adfdd14', __exports__)) {
    api.reload('4adfdd14', __exports__)
  }
  
  module.hot.accept("./LaborersAttendanceConfigClassmate.vue?vue&type=template&id=4adfdd14&scoped=true", () => {
    api.rerender('4adfdd14', render)
  })

}


export default __exports__